import { render, staticRenderFns } from "./UpdateSenderDialog.vue?vue&type=template&id=c46d3088&"
import script from "./UpdateSenderDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateSenderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports